<template>
  <!-- Lista „spadająca ocena” i zawieszeni w Bolcie (Bolt Fleet API 2.0, 29.10.2026). -->
  <v-expansion-panels v-if="data" class="mb-4 bolt-quality-panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="d-flex align-center">
          <v-icon small class="mr-2" :color="total ? 'warning' : 'grey'">mdi-star-circle-outline</v-icon>
          <span class="font-weight-medium mr-3">{{ $t('boltQuality.panelTitle') }}</span>
          <span class="text-caption" data-test="bolt-panel-summary">
            {{ $t('boltQuality.panelSummary', { declining: data.declining.length, suspended: data.suspended.length }) }}
          </span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div v-if="!total" class="text-caption">{{ $t('boltQuality.panelEmpty') }}</div>
        <template v-else>
          <v-simple-table v-if="data.declining.length" dense class="mb-3">
            <thead>
              <tr>
                <th>{{ $t('boltQuality.colDriver') }}</th>
                <th>{{ $t('boltQuality.colLast') }}</th>
                <th>{{ $t('boltQuality.colPrev') }}</th>
                <th>{{ $t('boltQuality.colReason') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in data.declining" :key="d.driverId">
                <td><a href="#" @click.prevent="open(d.driverId)">{{ d.name }}</a></td>
                <td>{{ d.last30.toFixed(2) }} ({{ d.last30Count }})</td>
                <td>{{ d.previous30 !== null ? d.previous30.toFixed(2) + ' (' + d.previous30Count + ')' : '—' }}</td>
                <td>{{ $t('boltQuality.declining.' + d.reason) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
          <div v-if="data.suspended.length">
            <div class="text-subtitle-2 mb-1">{{ $t('boltQuality.suspendedList') }}</div>
            <div v-for="z in data.suspended" :key="z.driverId" class="text-body-2 mb-1">
              <a href="#" @click.prevent="open(z.driverId)">{{ z.name }}</a>
              <span v-if="z.since" class="grey--text"> · {{ $t('boltQuality.suspendedSince', { date: fmt(z.since) }) }}</span>
              — {{ z.reasons.join('; ') }}
            </div>
          </div>
        </template>
        <div class="text-caption grey--text mt-2 pb-3">
          {{
            $t('boltQuality.panelThresholds', {
              rating: data.thresholds.rating,
              drop: data.thresholds.drop,
              min: data.thresholds.minRatings,
            })
          }}
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
const axios = require('axios');

export default {
  name: 'BoltQualityPanel',
  data: () => ({ data: null }),
  computed: {
    total() {
      return this.data ? this.data.declining.length + this.data.suspended.length : 0;
    },
  },
  async mounted() {
    try {
      const res = await axios.get(process.env.VUE_APP_ROOT_API + 'bolt/quality', {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      });
      this.data = res.data.data;
    } catch (e) {
      this.data = null; // brak uprawnień albo integracji — lista kierowców bez tej sekcji
    }
  },
  methods: {
    open(id) {
      location.href = '/driver-details?id=' + id;
    },
    fmt(d) {
      return d ? new Date(d).toLocaleDateString('pl-PL') : '';
    },
  },
};
</script>
